module.exports = __webpack_public_path__ + "static/media/spoonerism-task (2).bc53975b.mp3";